import { createStore, combineReducers } from 'redux';
import {
    cameras, dmses, detectors, detectorMaps, jwt, links, linkMaps,
    lanes, linkPollData, lanePollData, linkGeometries, nodes, userData
} from 'Reducers/index';
import {
    IJwt, IDmses, ICameras, IDetectors, IDetectorMaps, ILinks, ILinkMaps,
    ILanes, ILinkPollData, ILanePollData, INodes, ILinkGeometries, IUserData
} from "Store/index";

const rootReducer = combineReducers({
    cameras,
    detectors,
    detectorMaps,
    dmses,
    jwt,
    lanes,
    links,
    linkMaps,
    lanePollData,
    linkPollData,
    linkGeometries,
    nodes,
    userData
});

export interface IStore {
    cameras: ICameras,
    detectors: IDetectors,
    detectorMaps: IDetectorMaps,
    dmses: IDmses,
    jwt: IJwt,
    lanes: ILanes,
    links: ILinks,
    linkMaps: ILinkMaps,
    lanePollData: ILanePollData,
    linkPollData: ILinkPollData,
    linkGeometries: ILinkGeometries,
    nodes: INodes,
    userData: IUserData
}

export default function configureStore() {
    const store = createStore(rootReducer);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept([
            'Reducers/index',
            'Store/index'
        ], () => {
            const nextRootReducer = combineReducers({
                cameras,
                detectors,
                detectorMaps,
                dmses,
                jwt,
                lanes,
                links,
                lanePollData,
                linkPollData,
                nodes
            });
            store.replaceReducer(nextRootReducer as any);
        })
    }

    return store;
}